import { Component, Input } from "@angular/core";

@Component({
  selector: "ab-show-onboarding-checklist-callout",
  templateUrl: "./show-onboarding-checklist-callout.component.html",
})
export class ShowOnboardingChecklistCalloutComponent {
  @Input() public project: any;
}
